(() => {
  const DESKTOP_BREAKPOINT = 9920;

  const isMobileView = () => window.innerWidth < DESKTOP_BREAKPOINT;

  const initHeaderSearch = () => {
    document.querySelectorAll('.js-header-search-button').forEach(button => {
      button.addEventListener('click', event => {
        event.preventDefault();

        if (isMobileView()) {
          const search = document.querySelector('.js-header-mobile-search');
          if (!search) return;

          // TOGGLE
          if (search.classList.contains('active')) {
            search.classList.remove('active');
          } else {
            search.classList.add('active');
          }

        } else {
          const search = document.querySelector('.js-header-search');
          if (!search) return;

          // TOGGLE
          if (search.classList.contains('active')) {
            search.classList.remove('active');
          } else {
            search.classList.add('active');
          }
        }
      });
    });

    document.querySelectorAll('.js-close-header-search, .js-close-header-mobile-search').forEach(button => {
      button.addEventListener('click', event => {
        event.preventDefault();
        if (isMobileView()) {
          const search = document.querySelector('.js-header-mobile-search');
          if (search) search.classList.remove('active');
        } else {
          const search = document.querySelector('.js-header-search');
          if (search) search.classList.remove('active');
        }
      });
    });
  };

  initHeaderSearch();
})();